module.exports = __webpack_public_path__ + "img/all.7bea4dd4.svg";